(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bn26-early-access"] && !Shopify.designMode) return;
  try {
    
(function(){
  const nav=document.querySelector('.bn26-shortcuts:not(.bn26-category-shortcuts)');
  if(!nav)return;
  const filterName='filter.p.product_type';
  const forms='#FacetFiltersForm, #FacetFiltersFormMobile';
  const finders=[...nav.parentElement.querySelectorAll('[data-bn-cardio-finder]')];
  const finderGroups=finders.map(function(finder){return JSON.parse(finder.dataset.bnCardioTypes);});
  function readTypes(url){
    return [...new Set(url.searchParams.getAll(filterName).flatMap(function(value){return value.split(',');}))];
  }
  function targetFor(current,types){
    const target=new URL(current.href);
    ['page','section_id',filterName].forEach(function(key){target.searchParams.delete(key);});
    types.forEach(function(type){target.searchParams.append(filterName,type);});
    target.hash='';
    return target.pathname+target.search;
  }
  function preserveTypes(types){
    document.querySelectorAll(forms).forEach(function(form){
      const options=new Set([...form.querySelectorAll('input[type="checkbox"]')].filter(function(input){return input.name===filterName;}).map(function(input){return input.value;}));
      const missing=new Set(types.filter(function(type){return !options.has(type);}));
      form.querySelectorAll('input[data-bn-preserved-type]').forEach(function(input){
        if(!missing.has(input.value))input.remove();else missing.delete(input.value);
      });
      missing.forEach(function(type){
        const input=document.createElement('input');input.type='hidden';input.name=filterName;input.value=type;input.dataset.bnPreservedType='';form.appendChild(input);
      });
    });
  }
  function sync(){
    const current=new URL(window.location.href);
    const types=readTypes(current);
    const activeFinderIndex=types.length?finderGroups.findIndex(function(group){return types.every(function(type){return group.includes(type);});}):-1;
    const hasFilters=[...current.searchParams.keys()].some(function(key){return key.startsWith('filter.');});
    nav.querySelectorAll('[data-bn-group]').forEach(function(link){
      const group=JSON.parse(link.dataset.bnGroup);
      const finderIndex=finderGroups.findIndex(function(finderGroup){return group.length===finderGroup.length&&group.every(function(type){return finderGroup.includes(type);});});
      const active=finderIndex>=0?finderIndex===activeFinderIndex:types.length===group.length&&group.every(function(type){return types.includes(type);});
      link.classList.toggle('is-active',active);
      if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
      const icon=link.querySelector('.bn26-remove');if(icon)icon.hidden=!active;
      const target=new URL(current.href);
      ['page','section_id',filterName].forEach(function(key){target.searchParams.delete(key);});
      if(!active)group.forEach(function(type){target.searchParams.append(filterName,type);});
      link.href=target.pathname+target.search;
    });
    const reset=nav.querySelector('[data-bn-reset]');
    const target=new URL(current.href);
    [...target.searchParams.keys()].forEach(function(key){if(key.startsWith('filter.')||['page','section_id'].includes(key))target.searchParams.delete(key);});
    reset.href=target.pathname+target.search;
    reset.classList.toggle('bn26-chip-all',!hasFilters);
    const label=hasFilters?reset.dataset.clearLabel:reset.dataset.allLabel;
    if(reset.textContent!==label)reset.textContent=label;
    if(!hasFilters)reset.setAttribute('aria-current','true');else reset.removeAttribute('aria-current');
    finders.forEach(function(finder,index){
      const cardioTypes=finderGroups[index];
      const isCardio=index===activeFinderIndex;
      finder.hidden=!isCardio;
      let exactSubtype=false;
      finder.querySelectorAll('[data-bn-cardio-choice]').forEach(function(link){
        const choice=JSON.parse(link.dataset.bnCardioChoice);
        const active=isCardio&&choice.length===types.length&&choice.every(function(type){return types.includes(type);});
        link.classList.toggle('is-active',active);
        if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
        link.href=targetFor(current,choice)+'#'+finder.id;
        if(active&&choice.length<cardioTypes.length)exactSubtype=true;
      });
      const clear=finder.querySelector('[data-bn-cardio-clear]');
      clear.href=targetFor(current,cardioTypes)+'#'+finder.id;
      clear.hidden=!isCardio||types.length===cardioTypes.length;
      finder.querySelector('[data-bn-cardio-custom]').hidden=!isCardio||exactSubtype||types.length===cardioTypes.length;
    });
    document.querySelectorAll('.active-facets facet-remove, .active-facets-mobile facet-remove, .active-facets-desktop facet-remove').forEach(function(pill){
      const link=pill.querySelector('a.active-facets__button');
      if(!link)return;
      const remaining=readTypes(new URL(link.href,current));
      const isTypePill=activeFinderIndex>=0&&remaining.length===types.length-1&&remaining.every(function(type){return types.includes(type);});
      pill.classList.toggle('bn26-cardio-native-type',isTypePill);
    });
    preserveTypes(types);
  }
  nav.addEventListener('click',sync,true);
  document.addEventListener('change',function(event){if(event.target.closest('facet-filters-form'))sync();},true);
  document.addEventListener('input',function(event){if(event.target.closest('facet-filters-form'))sync();},true);
  window.addEventListener('popstate',sync);
  new MutationObserver(function(records){
    if(records.some(function(record){return !nav.contains(record.target)&&!finders.some(function(finder){return finder.contains(record.target);});}))sync();
  }).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn26-home-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bn26-home-marquee')) {
    customElements.define('bn26-home-marquee', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pauseButton = this.querySelector('.bn26-marquee__pause');
        this.userPaused = false;
        this.inView = false;
        this.classList.add('is-ready');
        this.pauseButton.hidden = false;
        this.pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseButton.setAttribute('data-paused', String(this.userPaused));
          this.pauseButton.setAttribute('aria-label', this.userPaused ? this.dataset.resume : this.dataset.pause);
          this.updateMotion();
        }, {signal});
        document.addEventListener('visibilitychange', () => this.updateMotion(), {signal});
        this.motion.addEventListener('change', () => this.updateMotion(), {signal});
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateMotion();
        });
        this.observer.observe(this);
        this.updateSchedule();
      }
      updateMotion() {
        this.classList.toggle('is-running', this.inView && !document.hidden && !this.userPaused && !this.motion.matches && !this.hidden);
      }
      updateSchedule() {
        clearTimeout(this.scheduleTimer);
        const now = Date.now();
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        const sundayEnd = Date.parse(this.dataset.sundayEnd);
        const saleActive = now < end;
        const sundayActive = now < sundayEnd;
        this.hidden = !saleActive && !sundayActive;
        this.querySelectorAll('[data-bn-sale]').forEach(node => { node.hidden = !saleActive; });
        this.querySelectorAll('[data-bn-sunday]').forEach(node => { node.hidden = !sundayActive; });
        this.classList.toggle('bn26-marquee--sunday-only', !saleActive && sundayActive);
        const message = now >= start ? this.dataset.live : this.dataset.upcoming;
        this.querySelectorAll('[data-bn-message]').forEach(node => { node.textContent = message; });
        this.updateMotion();
        const next = Math.min(...[start, end, sundayEnd].filter(boundary => boundary > now));
        if (Number.isFinite(next)) this.scheduleTimer = setTimeout(() => this.updateSchedule(), Math.min(next - now + 100, 2147483647));
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        clearTimeout(this.scheduleTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerGroup = document.querySelector('.shopify-section-group-header-group');
      const height = headerGroup ? headerGroup.offsetHeight : this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
